import React from 'react';
import { format } from 'date-fns';
import { de as deDateFns } from 'date-fns/locale';
import { useLang } from '../LangContext';

interface SlotCountProps {
  count: number;
  label: string;
  dayLabel: string;
  daysLabel: string;
}

const SlotCount = ({ count, label, dayLabel, daysLabel }: SlotCountProps) => (
  <span className="month-nav-count" title={label}>
    <span className="month-nav-count-num">{count}</span>
    <span className="month-nav-count-unit">{' '}{count === 1 ? dayLabel : daysLabel}</span>
    <span className="month-nav-count-short" aria-hidden="true">d</span>
  </span>
);

interface Props {
  currentMonthDate: Date;
  prevMonthSlots: number | null;
  nextMonthSlots: number | null;
  nextMonthDisabled: boolean;
  onPrev: () => void;
  onNext: () => void;
}

const MonthNav = ({
  currentMonthDate,
  prevMonthSlots,
  nextMonthSlots,
  nextMonthDisabled,
  onPrev,
  onNext,
}: Props) => {
  const { lang, t } = useLang();
  const locale = lang === 'de' ? deDateFns : undefined;
  return (
  <div className="month-nav">
    <div className="month-nav-side">
      <button onClick={onPrev} aria-label={t.navPrevMonth}>←</button>
      {prevMonthSlots !== null && (
        <SlotCount count={prevMonthSlots} label={t.slotCountPrevLabel} dayLabel={t.slotCountDay} daysLabel={t.slotCountDays} />
      )}
    </div>
    <span>{format(currentMonthDate, 'MMMM yyyy', { locale })}</span>
    <div className="month-nav-side">
      <button onClick={onNext} disabled={nextMonthDisabled} aria-label={t.navNextMonth}>→</button>
      {nextMonthSlots !== null && (
        <SlotCount count={nextMonthSlots} label={t.slotCountNextLabel} dayLabel={t.slotCountDay} daysLabel={t.slotCountDays} />
      )}
    </div>
  </div>
  );
};

export default MonthNav;
